import { render, staticRenderFns } from "./ApprovalInfo.vue?vue&type=template&id=1e71887e&"
import script from "./ApprovalInfo.vue?vue&type=script&lang=ts&"
export * from "./ApprovalInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ApprovalInfo.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports